import { $, $$, reducedMotion } from '@utils';

function init() {
  if (!$('video') || !reducedMotion.matches) return;

  reducedMotionCheck();
  reducedMotion.addEventListener('change', reducedMotionCheck);
}

function reducedMotionCheck() {
  $$('video').forEach((video) => {
    video.removeAttribute('autoplay');
    video.setAttribute('preload', 'none');
  });
}

export default { init };
